/**
 * pqkem.js — KEM post-quantum ML-KEM-768 (FIPS 203, ex-Kyber) via
 * @noble/post-quantum. Usato in modo IBRIDO con X25519 nell'handshake X3DH:
 * il segreto iniziale mescola DH classico + KEM PQ, così un avversario che
 * registra oggi non potrà decifrare domani con un computer quantistico
 * ("harvest now, decrypt later"). ⚠️ DA AUDIRE.
 */

import { ml_kem768 } from '@noble/post-quantum/ml-kem.js';

/** Genera una coppia di chiavi KEM. @returns {{pub:Uint8Array, secret:Uint8Array}} */
export function pqKeygen() {
  const { publicKey, secretKey } = ml_kem768.keygen();
  return { pub: publicKey, secret: secretKey };
}

/** Iniziatore: incapsula verso la pub del destinatario.
 *  @returns {{ct:Uint8Array, ss:Uint8Array}} ciphertext da spedire + segreto condiviso */
export function pqEncapsulate(pub) {
  const { cipherText, sharedSecret } = ml_kem768.encapsulate(pub);
  return { ct: cipherText, ss: sharedSecret };
}

/** Destinatario: decapsula il ciphertext con la propria secret. @returns {Uint8Array} ss */
export function pqDecapsulate(ct, secret) {
  return ml_kem768.decapsulate(ct, secret);
}
